import React from 'react';

export const LazyAdminDashboard = React.lazy(
  () => import(/* webpackChunkName: "routes--admin-dashboard" */ './admin-dashboard'),
);
